import gql from 'graphql-tag';

export const joinDivisionMutation = gql`
	mutation JoinDivision($id: ID) {
		joinDivision(id: $id) {
			id
		}
	}
`;
